import React, { useState } from "react";
import { ModalBuilder, Modal, Form } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";

const AgreementCoverUploadModal = ({
  triggerText,
  modalHeader,
  dealerId,
  submitAction,
  onSubmitted,
}) => {
  const [imageData, setImageData] = useState(null);

  const onChangeCoverImage = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setImageData(res);
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <ModalBuilder
      withForm
      submitAction={submitAction}
      submitParams={{ imageData, dealerId }}
      renderTrigger={(open) => (
        <Button primary onClick={open} content={triggerText} />
      )}
      onSubmitted={onSubmitted}
      renderModal={(modalProps, formProps) => (
        <Modal.Upload {...modalProps} header={modalHeader}>
          <Form {...formProps}>
            <Form.FileUpload
              field="image"
              fluid
              fileExtensionTypes={["png", "jpg", "jpeg", "svg"]}
              customValidator={(_, __, ___, { value }) => {
                !!value?.image && onChangeCoverImage(value?.image);
              }}
            />
          </Form>
        </Modal.Upload>
      )}
    />
  );
};

export default AgreementCoverUploadModal;
